require('../../../modules/es.array.flat');
require('../../../modules/es.array.unscopables.flat');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').flat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/flat.js
// module id = 3471
// module chunks = 25